( ( $ ) => {

	const mobileBelow = 992;
	const $el = $( '[data-blog-mobile-slider]' );

	const slickOptions = {
		arrows: false,
		dots: true,
	};

	if ( $el.length ) {
		$( window ).on( 'load resize', function () {
			if ( window.innerWidth > mobileBelow ) {
				if ( $el.hasClass( 'slick-initialized' ) ) {
					$el.slick( 'unslick' );
				}
			} else {
				if ( !$el.hasClass( 'slick-initialized' ) ) {
					$el.slick( slickOptions );
				}
			}
		} );
		$( window ).trigger( 'resize' );
	}


} )( jQuery )